<template>
  <div>
    <div v-show="artists.length>0" class="artists-painter__row">
      <template v-for="(artist, index) in artists">
        <artists-item-sub :artist="artist" :key="artist.artist_id"/>
      </template>
    </div>

    <div v-show="artists.length==0">
      <placeholder8
        name="artist"
        :text_html="$t('message.NothingToShow')"
      />
    </div>
  </div>
</template>

<script>
  import ArtistsListMix from "../../../../components/list/ArtistsListMix";
  import ArtistsComputedMix from "../../../../components/ArtistsComputedMix";
  import ArtistsItemSub from "./ArtistsItemSub";
  import Placeholder8 from "../../../../components/lib/placeholder8";

  export default {
    components: {Placeholder8, ArtistsItemSub },
    name: 'artists-listsub',
    mixins: [ArtistsListMix, ArtistsComputedMix],
  }
</script>



// WEBPACK FOOTER //
// src/sub/air_light/components/list/ArtistsListSub.vue